module.exports = __webpack_public_path__ + "static/media/1.3ab82f3f.jpeg";